import { useContext } from "react";
import { Link } from "react-router";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import ISupplier_Integration from "../../../../models/ISupplier_Integration";
import { WEBHOOK_DOCS_URL } from "../../BusinessSettings/Webhooks/webhookEvents";
import "./WebhooksConnect.scss";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";
import { SocketContext } from "../../../../contexts/SocketContext";

/**
 * Business Integrations tile that switches outbound webhooks on or off for the business. The
 * endpoints themselves are managed under Business Settings; this tile links there once enabled.
 */
export const WebhooksConnect = () => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext)!;

    const enabled = !!supplierModel.Supplier_Integration?.has_webhooks;

    const toggle = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            Supplier_Integration: { has_webhooks: !enabled } as ISupplier_Integration,
        };

        socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    return (
        <div className={"WebhooksConnect"} data-testid={"webhooks-connect"}>
            <OwAccordion
                hideChevron={true}
                titleClick={false}
                leftIcon={"fad fa-bolt"}
                title={"webhooks"}
                rightElem={
                    <div className={"ms-auto d-flex align-items-center gap-3"}>
                        {enabled ? (
                            <Link
                                className={"btn btn-sm btn-outline-secondary"}
                                to={"/business/settings"}
                                data-testid={"webhooks-connect-manage"}
                            >
                                <i className={"fad fa-sliders me-1"} aria-hidden={true} />
                                <OwLabel title={"manage_webhooks"} noBottomMargin={true} className={"pointer"} />
                            </Link>
                        ) : null}
                        <OwToggle fn={toggle} name={"has_webhooks"} label={""} active={enabled} />
                    </div>
                }
            ></OwAccordion>
            <div className={"WebhooksConnect-help"}>
                <OwLabel title={"webhooks_connect_help"} noBottomMargin={true} />
                <a href={WEBHOOK_DOCS_URL} target={"_blank"} rel={"noreferrer"}>
                    <i className={"fad fa-external-link-alt me-1"} aria-hidden={true} />
                    <OwLabel title={"view_webhook_docs"} noBottomMargin={true} className={"pointer"} />
                </a>
            </div>
        </div>
    );
};
